module.exports = __webpack_public_path__ + "9c0d35f8cc1a14799bf37fc1ca9fbc46.svg";